<template>
  <b-card>
    <div class="col-sm-12">
      <h4 class="h4-title">{{text.oneAppUserProfile}}</h4>
      <form>
        <b-form-group>
          <div class="text-center">
            <img
              class="thumbnail"
              :src="previewThumbnail"
              alt="Thumbnail"
            >
          </div>
          <div class="remove-avatar-ibtn"><button
              type="button"
              v-if="hasAvatar"
              class="btn"
              @click="removeAvatar"
              v-b-tooltip.hover
              title="Remove avatar"
            ><i class="fa fa-trash"></i></button></div>
          <b-input-group>
            <div class="custom-file">
              <input
                type="file"
                class="custom-file-input"
                @change="thumbnailFile"
              >
              <label class="custom-file-label"> {{text.chooseProfilePicture}} </label>
            </div>
          </b-input-group>
        </b-form-group>
        <b-row>
          <b-col
            class="form-group"
            cols="4"
          >
            <label for="formGroupExampleInput">{{text.firstName}}</label>
            <input
              type="text"
              class="form-control"
              id="first-name"
              :placeholder="text.firstName"
              v-model="UserProfile.firstName"
              required
            >
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label for="formGroupExampleInput">{{text.middleName}}</label>
            <input
              type="text"
              class="form-control"
              id="middle-name"
              :placeholder="text.middleName"
              v-model="UserProfile.middleName"
              required
            >
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label for="formGroupExampleInput">{{text.lastName}}</label>
            <input
              type="text"
              class="form-control"
              id="last-name"
              :placeholder="text.lastname"
              v-model="UserProfile.lastName"
              required
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.mobile}}</label>
            <the-mask class="form-control" :mask="['###-###-####']" v-model="UserProfile.mobile" :masked="false" type="tel" placeholder="xxx-xxx-xxxx" />
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.email}}</label>
            <label class="form-control">{{UserProfile.email}}</label>
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.idCard}}</label>
            <input
              type="text"
              class="form-control"
              id="idCardNumber"
              :placeholder="text.idCard"
              v-model="UserProfile.idCardNumber"
              required
            >
          </b-col>
          <b-col
            class="form-group"
            cols="4"
            v-if="isVerified"
          >
            <label>{{text.userVerifiedAt}}</label>
            <label class="form-control">{{toLocalDateTime(UserProfile.verifiedAt.timestamp)}}</label>
          </b-col>
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.userStatus}}</label>
            <b-form-checkbox
              v-model="userStatus"
              name="check-button"
              switch
              @change="changeStatus"
              size="lg"
            >{{userStatusText}}
            </b-form-checkbox>
          </b-col>
          <!-- tenant -->
          <b-col
            class="form-group"
            cols="4"
          >
            <label>{{text.userType}}</label>
            <v-select :clearable="false"
                  v-model="UserProfile.userType"
                 :options="['tenant', 'owner']">
            </v-select>
            <div class="mt-3" v-if="'tenant' === UserProfile.userType">
              <label>Rent Date</label>
              <v-date-picker
                    mode='range'
                    locale="th-TH"
                    color="gray"
                    :columns="$screens({ default: 1, lg: 2 })"
                    :popover="{ visibility: 'click', placement: 'right' }"
                    :input-props="{ placeholder: 'Please enter date start and finish', readonly: true }"
                    v-model='rentDate'
                    >
                </v-date-picker>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div
            class="col-sm-2 col-100"
            v-if="!isVerified"
          >
            <button
              type="button"
              class="btn action-b-btn b-btn"
              @click="resendVerificationEmail"
            >{{text.verify}}</button>
          </div>
          <div
            class="col-sm-2 col-100"
            style="display:none;"
          >
            <button
              type="button"
              class="btn action-b-btn b-btn"
            >{{text.activateDeactivate}}</button>
          </div>
          <div class="col-sm-2 col-100">
            <button
              type="button"
              class="btn action-b-btn b-btn"
              :disabled="isUpdating"
              @click="updateUserInfo"
            >
              <b-spinner
                small
                v-if="isUpdating"
              ></b-spinner>
              {{updateBtnCaption}}
            </button>
          </div>
          <div class="col-sm-2 col-100">
            <button
              type="button"
              class="btn action-b-btn b-btn"
              @click="addProject"
              v-if="allProject"
            >
              {{text.addProject}}
            </button>
          </div>
        </b-row>
        <hr />
        <div>
          <div class="form-group row">
            <div class="col-lg-12">
              <b-alert
                variant="success"
                dismissible
                fade
                :show="saveDone"
              >
                {{successMessage}}
              </b-alert>
              <b-alert
                variant="danger"
                dismissible
                fade
                :show="saveError"
              >
                <span v-html="errorMessage"></span>
              </b-alert>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-sm-12">
      <h4>{{text.ownerProjects}}</h4>
      <b-row
        v-for="(projectOwner) in projectsOwner"
        v-bind:key="projectOwner.code"
      >
        <b-col>
          <div>
            <h5>{{projectOwner.name}}</h5>
            <b-button
              size="sm"
              class="mr-1 grant-b-btn btn-add-unit"
              @click="addUnit(projectOwner.code, projectOwner.name)"
              v-b-tooltip.hover
              :title="text.addUnitToProject"
            >
              {{text.addUnit}}
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              class="mr-1 btn-add-unit"
              v-if="allProject"
              @click="deleteProject(projectOwner.code)"
              v-b-tooltip.hover
              :title="text.deleteProjectTitle"
            >
              {{text.deleteProject}}
            </b-button>
          </div>
          <div>
            <b-table
              stacked="sm"
              class="table-app"
              tbody-class="tbody"
              hover
              thead-tr-class="thead-app"
              selectedVariant="single"
              :selectable="true"
              :fields="fields"
              :items="projectOwner.units"
            >
              <template
                slot="unitNumber"
                slot-scope="row"
              >
                {{ row.item.unitNumber }}
              </template>
              <template
                slot="gateway"
                slot-scope="row"
              >
                {{ row.item.gateway }}
              </template>
              <template
                slot="createdAt"
                slot-scope="row"
              >
                {{ toLocalDateTime(row.item.createdAt.timestamp) }}
              </template>
              <template
                slot="updatedAt"
                slot-scope="row"
              >
                {{ toLocalDateTime(row.item.updatedAt.timestamp) }}
              </template>
              <template
                slot="actions"
                slot-scope="row"
              >
                <b-button
                  size="sm"
                  class="mr-1 grant-b-btn"
                  @click="grantAccess(row.item.id, projectOwner.code, setGrantRevokeAction(row.item.userAuthority))"
                  v-b-tooltip.hover
                  title="Grant/Revoke access to room."
                >
                {{ capitalizeGRAction(setGrantRevokeAction(row.item.userAuthority)) }}

                </b-button>
                <b-button
                  type="button"
                  size="sm"
                  class="btn btn-edit-transparent"
                  @click="row.toggleDetails"
                  v-b-tooltip.hover
                  :title="row.detailsShowing ? text.hide : text.edit"
                >
                  <i :class="row.detailsShowing ? 'fa fa-eye-slash' : 'fa fa-edit'"></i>
                </b-button>
                <button
                  type="button"
                  class="btn"
                  @click="deleteUnit(projectOwner.code, row.item.id)"
                  v-b-tooltip.hover
                  title="Delete"
                ><i class="fa fa-trash"></i></button>
              </template>
              <template v-slot:row-details="row">
                <Unit
                  v-bind:unitProp="row.item"
                  :id="id"
                  :projectcode='projectOwner.code'
                ></Unit>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import { dateToStringWithTimeFull } from '@/assets/utils/time.js';
import Unit from '@/views/oneapp/Unit.vue';
import { currentUserProjects } from '@/assets/utils/user';
import MqdcOneClient from '@/models/mqdc-one-client';
import { textUserProfiles } from '../../assets/utils/language';
import { TheMask } from 'vue-the-mask';
import { PNF, phoneUtil } from '@/assets/utils/phone-util';
import vSelect from 'vue-select';
import moment from 'moment';

export default {
  name: 'UserProfile',
  props: ['id'],
  data () {
    return {
      rentDate: {
        start: null,
        end: null
      },
      UserProfile: {},
      projectsOwner: [],
      previewThumbnail: '/images/avatars/default.jpg',
      thumbnail: {},
      updatedAvatar: false,
      saveDone: false,
      saveError: false,
      loading: false,
      appId: '',
      editMode: false,
      saveClicked: false,
      readyToSave: false,
      isVerified: false,
      isUpdating: false,
      userStatus: false,
      hasAvatar: false,
      allProject: true,
      userStatusText: '',
      grantText: 'grant',
      revokeText: 'revoke',
      updateBtnCaption: 'Update',
      updateBtnCaptionDefault: 'Update',
      updateBtnCaptionUpdating: 'Updating user information....',
      pageTitle: 'One App: User Profile',
      successMessage: 'Successfully updated.',
      errorMessage: 'Error',
      userUpdateSuccessMessage: 'Updated user information successfully!',
      userUpdateErrorMessage: 'Error updating user information.',
      confirmUserUpdateMessage: 'Are you sure to update user information?',
      uploadAvatarErrorMessage: 'Error uploading avatar.',
      removeAvatarWarning: 'Are you sure to remove avatar?',
      removeAvatarSuccess: 'Removed avatar successfully.',
      deleteUnitWarning: 'Are you sure to delete this Unit?',
      deleteUnitSuccess: 'Deleted Unit successfully.',
      deleteProjectWarning: 'Are you sure to delete this Project?',
      deleteProjectSuccess: 'Deleted Project successfully.',
      grantWarning: 'Are you sure to grant access to this Unit?',
      revokeWarning: 'Are you sure to revoke access to this Unit?',
      grantSuccess: 'Access has been granted.',
      revokeSuccess: 'Access has been revoked.',
      fields: [],
      form: {
        firstName: '',
        lastName: '',
        middleName: '',
        mobile: '',
        idCardNumber: ''
      },
      confirmBoxOptions: {
        title: 'Please confirm!',
        text: '',
        type: 'question',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#339DAA',
        cancelButtonText: 'No',
        cancelButtonColor: '#d33',
        width: 500,
        animation: true,
        padding: '3em',
        background: '#fff'
      },
      alertBoxOptions: {
        confirmButtonColor: '#339DAA'
      },
      mqdcOneClient: {},
      text: {}
    };
  },
  created: function () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    this.getProfile();
    document.title = 'One App: User Profile';
  },
  methods: {
    setGrantRevokeAction (grAction) {
      let actionText = this.grantText;
      if (grAction !== null && grAction) {
        if ('grant' === grAction) {
          actionText = this.revokeText;
        } else if ('revoke' === grAction) {
          actionText = this.grantText;
        }
      }
      return actionText;
    },
    capitalizeGRAction (grAction) {
      return grAction.charAt(0).toUpperCase() + grAction.slice(1);
    },
    filterProjectByPermission () {
      const projectPermission = currentUserProjects();
      if (projectPermission.length > 0) {
        const permittedProjects = this.projectsOwner.filter(po => {
          return projectPermission.includes(po.code);
        });
        if (permittedProjects.length > 0) {
          this.allProject = false;
          if (!projectPermission.includes('*')) {
            this.projectsOwner = permittedProjects;
          }
        }
      }
    },
    thumbnailFile (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.form.thumbnail = files[0];
      this.form.isDefaultThumbnail = false;
      this.updatedAvatar = true;
      this.previewThumbnail = URL.createObjectURL(this.form.thumbnail);
    },
    async getProfile () {
      try {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/profile`;
        const userProfile = await this.mqdcOneClient.getAxios().then(axios => {
          return axios.get(
            url
          )
          ;
        });
        if (!userProfile) {
          this.$router.push({ name: 'one_app_profiles' });
        }
        this.UserProfile = userProfile.data.data;
        if (this.UserProfile.mobile) {
          this.UserProfile.mobile = phoneUtil.format(phoneUtil.parseAndKeepRawInput(this.UserProfile.mobile, 'TH'), PNF.NATIONAL);
        }
        this.isVerified = !!this.UserProfile.verifiedAt;
        this.userStatus = 'enable' === this.UserProfile.status;
        if ('tenant' === this.UserProfile.userType) {
          this.rentDate = {
            start: new Date(this.UserProfile.tenantPeriodStart.timestamp * 1000),
            end: new Date(this.UserProfile.tenantPeriodEnd.timestamp * 1000)
          };
        }
        this.userStatusText = this.userStatus ? this.text.active : this.text.notActive;
        if (this.UserProfile.avatar) {
          this.previewThumbnail = this.UserProfile.avatar.medium;
          this.hasAvatar = true;
        }
        this.projectsOwner = this.UserProfile.projectsOwner;
        this.filterProjectByPermission();
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    toLocalDateTime (dt) {
      return dateToStringWithTimeFull(new Date(dt * 1000));
    },
    grantAccess (unitId, projectCode, userAuthority) {
      this.confirmBoxOptions.text = 'revoke' === userAuthority ? this.revokeWarning : this.grantWarning;
      let alertMessage = 'revoke' === userAuthority ? this.revokeSuccess : this.grantSuccess;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          const unitAuthority = {
            userAuthority: userAuthority
          };
          const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/projects/${projectCode}/units/${unitId}`;
          try {
            this.mqdcOneClient.getAxios().then(axios => {
              axios.patch(
                url, unitAuthority).then(response => {
                if ('UNT-000' === response.data.code) {
                  this.getProfile();
                  this.$alert(alertMessage, 'Success', 'success', this.alertBoxOptions).then(() => { });
                }
              })
                .catch(error => {
                  this.saveError = true;
                  this.saveDone = false;
                  this.successMessage = '';
                  this.errorMessage = error.response.data.message;
                  this.$alert(`${error.response.data.message}`, 'Error', 'error').then(() => { });
                  console.log(error.response.data);
                });
            });
          } catch (err) {
            console.log('Error : ', err);
          }
        }
      });
    },
    changeStatus (e) {
      this.userStatusText = e ? this.text.active : this.text.notActive;
    },
    async updateUserInfo () {
      this.confirmBoxOptions.text = this.confirmUserUpdateMessage;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          this.isUpdating = true;
          this.updateBtnCaption = this.updateBtnCaptionUpdating;
          if (this.updatedAvatar) {
            try {
              const fdAvatar = new FormData();
              fdAvatar.append('avatar', this.form.thumbnail);
              const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/avatar`;
              this.mqdcOneClient.getAxios().then(axios => {
                axios.patch(
                  url, fdAvatar).then(response => {
                  this.updatedAvatar = false;
                  this.saveUserInformation();
                })
                  .catch(error => {
                    this.saveDone = false;
                    this.saveError = true;
                    this.updatedAvatar = false;
                    this.successMessage = '';
                    this.errorMessage = error.response.data.message;
                    console.log(error.response.data);
                    this.$alert(
                      this.uploadAvatarErrorMessage,
                      'Error',
                      'error'
                    ).then(() => { });
                    this.isUpdating = false;
                    this.updateBtnCaption = this.updateBtnCaptionDefault;
                  });
              });
            } catch (err) {
              console.log('Error ===>>>', err);
              this.updatedAvatar = false;
            }
          } else {
            this.saveUserInformation();
          }
        } else {
          this.isUpdating = false;
          this.updateBtnCaption = this.updateBtnCaptionDefault;
        }
      });
    },
    resendVerificationEmail () {
      const emailToVerify = {
        'email': this.UserProfile.email
      };
      try {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/resend-verification-email`;
        this.mqdcOneClient.getAxios().then(axios => {
          axios.post(
            url, emailToVerify).then(response => {
            this.successMessage = response.data.message;
            this.saveDone = true;
          })
            .catch(error => {
              this.saveError = true;
              this.saveDone = false;
              this.successMessage = '';
              this.errorMessage = error.response.data.message;
              console.log(error.response.data);
            });
        });
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    saveUserInformation () {
      const userProfilePatch = {
        'firstName': this.UserProfile.firstName,
        'lastName': this.UserProfile.lastName,
        'middleName': this.UserProfile.middleName,
        'mobile': this.UserProfile.mobile,
        'idCardNumber': this.UserProfile.idCardNumber,
        'status': this.userStatus ? 'enable' : 'disable',
        'userType': this.UserProfile.userType,
        'tenantPeriodStart': this.tenantPeriodStart,
        'tenantPeriodEnd': this.tenantPeriodEnd
      };
      try {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/profile`;
        this.mqdcOneClient.getAxios().then(axios => {
          axios.patch(url, userProfilePatch).then(response => {
            this.successMessage = this.userUpdateSuccessMessage;
            this.saveDone = true;
            this.$alert(this.userUpdateSuccessMessage, 'Success', 'success', this.alertBoxOptions).then(() => { });
            this.isUpdating = false;
            this.updateBtnCaption = this.updateBtnCaptionDefault;
            if (response.data.data.avatar) {
              this.previewThumbnail = response.data.data.avatar.medium;
              this.hasAvatar = true;
            }
          })
            .catch(error => {
              this.saveError = true;
              this.saveDone = false;
              this.successMessage = '';
              if (error.response && 'UPF-201' === error.response.data.code) {
                this.errorMessage = this.text.wrongFormatMobileNumber;
              } else {
                this.errorMessage = this.userUpdateErrorMessage + (error.response.data && error.response.data.message ? ' : ' + error.response.data.message : '');
              }
              this.$alert(this.errorMessage, 'Error', 'error').then(() => { });
              console.log(error.response);
              this.isUpdating = false;
              this.updateBtnCaption = this.updateBtnCaptionDefault;
            });
        });
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    removeAvatar () {
      this.confirmBoxOptions.text = this.removeAvatarWarning;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          try {
            const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/avatar`;
            this.mqdcOneClient.getAxios().then(axios => {
              axios.delete(url).then(response => {
                if (!response.data.data.avatar) {
                  this.previewThumbnail = '/images/avatars/default.jpg';
                  this.hasAvatar = false;
                }
                this.$alert(this.removeAvatarSuccess, 'Success', 'success', this.alertBoxOptions).then(() => { });
              })
                .catch(error => {
                  console.log('Delete Err ===> ', error.response);
                  this.$alert('Unexpected Error.', 'Error', 'error').then(() => { });
                });
            });
          } catch (err) {
            console.log('Error ===>>>', err);
          }
        }
      });
    },
    addProject () {
      this.$router.push({ name: 'one_app_profiles-project' });
    },
    addUnit (projectCode, projectName) {
      sessionStorage.setItem('projectname', projectName);
      this.$router.push({ name: 'one_app_profiles-unit', params: { id: this.id, projectcode: projectCode } });
    },
    deleteUnit (projectCode, unitId) {
      this.confirmBoxOptions.text = this.deleteUnitWarning;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          try {
            const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/projects/${projectCode}/units/${unitId}`;
            this.mqdcOneClient.getAxios().then(axios => {
              axios.delete(url).then(response => {
                this.getProfile();
                this.$alert(this.deleteUnitSuccess, 'Success', 'success', this.alertBoxOptions).then(() => { });
              })
                .catch(error => {
                  console.log('Delete Err ===> ', error.response);
                  this.$alert('Unexpected Error.', 'Error', 'error').then(() => { });
                });
            });
          } catch (err) {
            console.log('Error ===>>>', err);
          }
        }
      });
    },
    deleteProject (projectCode) {
      this.confirmBoxOptions.text = this.deleteProjectWarning;
      this.$fire(this.confirmBoxOptions).then((r) => {
        if (r.value) {
          try {
            const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/projects/${projectCode}`;
            this.mqdcOneClient.getAxios().then(axios => {
              axios.delete(url).then(response => {
                this.getProfile();
                this.$alert(this.deleteProjectSuccess, 'Success', 'success', this.alertBoxOptions).then(() => { });
              })
                .catch(error => {
                  console.log('Delete Err ===> ', error);
                });
            });
          } catch (err) {
            console.log('Error ===>>>', err);
          }
        }
      });
    },
    refreshLanguage () {
      this.updateBtnCaption = this.text.update;
      this.updateBtnCaptionDefault = this.text.update;
      this.userStatusText = this.userStatus ? this.text.active : this.text.notActive;
      this.confirmBoxOptions.title = this.text.pleaseConfirm;
      this.confirmBoxOptions.confirmButtonText = this.text.yes;
      this.confirmBoxOptions.cancelButtonText = this.text.no;
      this.deleteProjectWarning = this.text.askDeleteProject;
      this.userUpdateSuccessMessage = this.text.userUpdateSuccessMessage;
      this.userUpdateErrorMessage = this.text.userUpdateErrorMessage;
      this.confirmUserUpdateMessage = this.text.confirmUserUpdateMessage;
      this.uploadAvatarErrorMessage = this.text.uploadAvatarErrorMessage;
      this.removeAvatarWarning = this.text.removeAvatarWarning;
      this.removeAvatarSuccess = this.text.removeAvatarSuccess;
      this.deleteUnitWarning = this.text.deleteUnitWarning;
      this.deleteUnitSuccess = this.text.deleteUnitSuccess;
      this.deleteProjectSuccess = this.text.deleteProjectSuccess;
      this.grantWarning = this.text.grantWarning;
      this.revokeWarning = this.text.revokeWarning;
      this.grantSuccess = this.text.grantSuccess;
      this.revokeSuccess = this.text.revokeSuccess;
      this.fields = [
        { key: 'unitNumber', label: this.text.unitNumber },
        { key: 'gateway', label: this.text.gateway },
        { key: 'port1', label: this.text.port1 },
        { key: 'port2', label: this.text.port2 },
        { key: 'createdAt', label: this.text.createdAt },
        { key: 'updatedAt', label: this.text.updatedAt },
        { key: 'actions', label: this.text.actions }];
    }
  },
  computed: {
    tenantPeriodStart () {
      if (!this.rentDate.start) return null;
      const date = moment(this.rentDate.start);
      return date.utc().format('YYYY-MM-DD HH:mm');
    },
    tenantPeriodEnd () {
      if (!this.rentDate.end) return null;
      const date = moment(this.rentDate.end);
      return date.hour(23).minute(59).utc().format('YYYY-MM-DD HH:mm');
    }
  },
  components: {
    Unit,
    TheMask,
    'v-select': vSelect
  },
  mounted () {
    this.text = textUserProfiles(this.$language);
    this.refreshLanguage();
  },
  watch: {
    $language: function () {
      this.text = textUserProfiles(this.$language);
      this.refreshLanguage();
    }
  }
};
</script>
<style scoped src="@/assets/css/userprofile.css"></style>
